module.exports = function() {
  return new Worker(__webpack_public_path__ + "89d2b95a3a1e131be439.worker.js");
};